import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Watchlist() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    role: "Artist",
    link: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1️⃣ Send email to user
      await emailjs.send(
        "service_f055kya", //service ID put in env file
        "template_htclz0r", // user template ID put in env file
        {
          to_email: form.email,
          full_name: form.fullName,
          phone: form.phone,
          role: form.role,
          link: form.link || "N/A",
        },
        "FeJD_kM1e0tvi4MfV" // public key put in env file
      );

      // 2️⃣ Send email to you (admin)
      await emailjs.send(
        "service_f055kya", //service ID put in env file
        "template_8ghmnkg", // admin template ID put in env file
        {
          admin_email: "nkechukwu@nv.luxury",
          full_name: form.fullName,
          email: form.email,
          phone: form.phone,
          role: form.role,
          link: form.link
        },
        "FeJD_kM1e0tvi4MfV" // public key put in env file
      );

      alert("You're on the waitlist 🎉");

      setForm({
        fullName: "",
        email: "",
        phone: "",
        role: "Artist",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to join waitlist.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="waitlist-div" id="waitlist">
        <h2 className="appear" style={{fontSize: "40px", paddingTop:"40px"}}>Join the Waitlist</h2>
        <p className="appear" style={{fontFamily: "Inter, sans-serif", fontWeight: "200", fontSize: "18px", marginBottom: "70px"}}>Be among the first to experience the future of luxury commerce. Get early access when we launch.</p>
        <form
            onSubmit={handleSubmit}
            // style={{
            //     maxWidth: 480,
            //     padding: 24,
            //     borderRadius: 12,
            //     margin: "auto",
            //     backgroundColor:"#262626"
            // }}
            className="glass-form appear"
            >
            

            <input
                name="fullName"
                placeholder="Full Name"
                value={form.fullName}
                onChange={handleChange}
                required
                style={inputStyle}
            />

            <input
                name="email"
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
                style={inputStyle}
            />

            <input
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
                required
                style={inputStyle}
            />

            {/* Role dropdown aligned right */}
            <div
                style={{
                display: "flex",
                justifyContent: "flex-end",
                width:"45%",
                paddingTop: 17,
                
                }}
            >
                <select
                name="role"
                value={form.role}
                onChange={handleChange}
                style={{
                    padding: 8,
                    color: "rgb(180 179 179)"
                }}
                required
                >
                <option value="Artist">Artist</option>
                <option value="Jeweller">Jeweller</option>
                </select>
            </div>

            <input
              name="link"
              placeholder="Linkedin or Portfolio link (optional)"
              value={form.link}
              onChange={handleChange}
              style={{...inputStyle, width: "88%"}}
            />

            <button
                type="submit"
                disabled={loading}
                style={{
                width: "92%",
                padding: 12,
                marginTop: 24,
                backgroundColor: "#FE9A00",
                outline: "none",
                border: "none",
                fontWeight: "400",
                color: "white",
                cursor: loading ? "not-allowed" : "pointer",
                borderRadius: "7px",
                fontFamily: "Inter",
                fontSize: "14px",
                }}
            >
                {loading ? "Joining..." : "Join Waitlist"}
            </button>
        </form>
    </div>
    
  );
}

const inputStyle = {
  width: "40%",
  padding: 8,
  marginTop: 12,
};
